<template>
    <form
        @submit.prevent="register"
        :action="urls.register"
        method="POST"
        class="p-4 bg-white rounded shadow"
    >
        <div class="space-y-4">
            <h1 class="text-3xl tracking-wide font-bold py-4 text-center text-gray-800">Register</h1>

            <div class="mx-auto w-16 border-b-2 border-gray-300"></div>

            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <text-input
                    v-model="form.first_name"
                    label="First Name"
                    name="first_name"
                    placeholder="Paul"
                    :error="form.errors.first_name"
                />
                <text-input
                    v-model="form.last_name"
                    label="Last Name"
                    name="last_name"
                    type="text"
                    placeholder="Bunyan"
                    :error="form.errors.last_name"
                />
            </div>

            <text-input
                v-model="form.email"
                label="Email"
                name="email"
                type="email"
                placeholder="paul.bunyan@example.com"
                :error="form.errors.email"
            />

            <text-input
                v-model="form.password"
                label="Password"
                name="password"
                type="password"
                placeholder="Password"
                :error="form.errors.password"
            />

            <text-input
                v-model="form.password_confirmation"
                label="Confirm Password"
                name="password_confirmation"
                type="password"
                placeholder="Password"
            />

            <div class="flex flex-col space-y-4">
                <loading-button
                    :loading="form.processing"
                    type="submit"
                    class="btn btn-green"
                >
                    Register
                </loading-button>

                <div class="underline text-center text-gray-600 hover:text-gray-900">
                    <a href="/login">Already have an account?</a>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import Form from '@/functions/Form'
import TextInput from "./shared/TextInput"
import LoadingButton from './shared/LoadingButton.vue'

export default {
    props: {
        urls: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            form: Form({
                first_name: '',
                last_name: '',
                email: '',
                password: '',
                password_confirmation: '',
            })
        }
    },
    methods: {
        register() {
            this.form.post(this.urls.register, {
                onSuccess: ({ redirect_to }) => window.location.assign(redirect_to),
            })
        }
    },
    components: {
        TextInput,
        LoadingButton,
    },
}
</script>
